const MESSAGES = {
    FIELD_REQUIRED: 'This field is required.',
    ENTER_EMAIL_ADDRESS: 'Enter Email Address.', 
    ENTER_PASSWORD: 'Enter Password.', 

    APPOINTMENT_UPCOMING: 'Upcoming', 
    APPOINTMENT_COMPLETED: 'Completed',
    APPOINTMENT_MISSED: 'Missed',

    ENTER_VALID_EMAIL_ADDRESS: 'Enter Valid Email Address.',
    ENTER_VALID_MOBILE_NUMBER: 'Enter Valid Mobile Number.', 
    ENTER_VALID_ALT_MOBILE_NUMBER: 'Enter Valid Alternate Mobile Number.', 
    ENTER_VALID_EMERG_CONTACT_NUMBER: 'Enter Valid Emergency Contact Number.', 

    MOBILE_NUMBER_TEN_DIGIT: 'Mobile Number should be 10 digit only.', 
    ALT_MOBILE_NUMBER_TEN_DIGIT: 'Alternate Mobile Number should be 10 digit only.', 
    EMERG_CONTACT_NUMBER_TEN_DIGIT: 'Emergency Contact Number should be 10 digit only.', 
    PAN_CARD_TEN_DIGIT: 'PAN Card Number length should be 10 only.', 
    AADHAR_CARD_TWELVE_DIGIT: 'Aadhar Card Number should be 12 digit only.', 

    EXIT_DATE_SHOULD_NOT_BE_BLANK: 'Exit date should not be blank.'
}

export default MESSAGES;